'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/react/react.js
 ** module id = 101
 ** module chunks = 2
 **/